import { Box, Link, Typography } from "@mui/material";
import { BackgroundTypography } from "components/Text";
import { DomainColorSquares } from "components/Requirements/DomainColorSquares";
import { SuccessRubric } from "modals/SuccessRubric";
import { FC, memo, useState } from "react";
import { CustomLabel } from "types/CustomLabel";
import { Requirement } from "types/requirement";

type RequirementBoxProps = {
  requirement: Requirement;
  customLabels?: CustomLabel[];
};
const RequirementBoxComponent: FC<RequirementBoxProps> = ({
  requirement,
  customLabels = [],
}) => {
  const [openSuccessRubric, setOpenSuccessRubric] = useState(false);

  return (
    <Box key={requirement.requirement_id}>
      <Box
        sx={{
          position: "relative",
        }}
      >
        <Box sx={{ mb: 0.5 }}>
          <BackgroundTypography text={requirement.name} />
        </Box>

        <Typography variant="body1">
          {requirement.overview ?? requirement.description}
        </Typography>
        <Box mt={1}>
          <DomainColorSquares requirement={requirement} size={12} />
        </Box>
        {requirement.evaluation_metrics &&
          requirement.evaluation_metrics?.length > 0 && (
            <Box display="flex" justifyContent="flex-end" mt={2} mb={1}>
              <Link
                onClick={() => {
                  setOpenSuccessRubric(true);
                }}
                sx={{ cursor: "pointer" }}
              >
                See Success Rubric
              </Link>
            </Box>
          )}
      </Box>
      {openSuccessRubric && requirement && (
        <SuccessRubric
          open={openSuccessRubric}
          onClose={() => setOpenSuccessRubric(false)}
          requirement={requirement}
          customLabels={customLabels}
        />
      )}
    </Box>
  );
};

export const RequirementBox = memo(RequirementBoxComponent);
